/**
 * Map from language codes to Postgres text search regconfig names.
 * Used for computing FTS (tsvector) on chunks.
 */
export const REGCONFIG_MAP: Record<string, string> = {
  en: "english",
  sv: "swedish",
  no: "norwegian",
  da: "danish",
  fi: "finnish",
  de: "german",
  fr: "french",
  es: "spanish",
  it: "italian",
  pt: "portuguese",
  nl: "dutch",
  ru: "russian",
};

/** Reverse map: regconfig name → 2-letter language code. */
export const REGCONFIG_TO_LANG: Record<string, string> = Object.fromEntries(
  Object.entries(REGCONFIG_MAP).map(([code, regconfig]) => [regconfig, code]),
);

/** All valid Postgres regconfig values we support (for SQL injection prevention). */
const VALID_REGCONFIGS = new Set(["simple", ...Object.values(REGCONFIG_MAP)]);

/**
 * Validate and return a safe regconfig string.
 * Throws if the value isn't in our known whitelist.
 * Use this instead of sql.raw() interpolation.
 */
export function safeRegconfig(value: string): string {
  if (!VALID_REGCONFIGS.has(value)) {
    return "simple";
  }
  return value;
}

/**
 * Resolve a language code (or full regconfig name) to a safe regconfig.
 * Returns "simple" for unknown values.
 */
export function resolveRegconfig(language: string): string {
  const mapped = REGCONFIG_MAP[language] ?? language;
  return safeRegconfig(mapped);
}
